import { Grid, Typography } from "@mui/material";

export default function HowToUpload() {
  return (
    <Grid item container spacing={3} p={1} m={2}>
      <Grid item xs={5}>
        <Typography fontSize={18} fontWeight={700}>
          Uploading
        </Typography>
        <Typography>
          In this application, you can upload various types of documents and
          images, such as doc, pdf, jpg, png, gif, but not video files. This
          video tells you how to upload a document or image
        </Typography>
      </Grid>
      <Grid item xs={6} display="flex" alignSelf="start" marginLeft={4}>
  {/*       <video width="100%" height="auto" controls>
          <source
            src={require("../../assets/videos/sample.mp4")}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video> */}
      </Grid>
    </Grid>
  );
}
